import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import * as getters from './getters'
import auth from './modules/auth'
import catatanForm from './modules/catatan-form'
import formData from './modules/form-data'
import verification from './modules/verification'
import jenjang from './modules/jenjang'
import jalur from './modules/jalur'
import tahun from './modules/tahun'
import fakultas from './modules/fakultas'
import programStudi from './modules/program-studi'
import penawaranJalur from './modules/penawaran-jalur'
import penawaranJalurAktif from './modules/penawaran-jalur-aktif'
import createLogger from 'vuex/dist/logger'
import loa from './modules/loa'
import statusPendaftar from './modules/status-pendaftar'
import pengumuman from './modules/pengumuman'
import artikel from './modules/artikel'
import chat from './modules/chat'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  key: 'vuex-admisi-client',
  storage: window.localStorage
})

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  getters,
  modules: {
    auth,
    catatanForm,
    formData,
    jenjang,
    jalur,
    programStudi,
    fakultas,
    penawaranJalur,
    penawaranJalurAktif,
    tahun,
    verification,
    loa,
    statusPendaftar,
    pengumuman,
    artikel,
    chat
  },
  strict: debug,
  plugins: debug ? [createLogger(), vuexLocal.plugin] : [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js